const LogoutNavIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width='24'
    height='27'
    viewBox='0 0 24 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={`stroke-green-800 ${className}`}
  >
    <path
      d='M21.0038 13.2891L16.0017 7.76416'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.0017 18.814L21.0038 13.2891'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M21.0037 13.2893H9.99915'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.99913 23.2338H7.66483C5.08643 23.2338 2.99622 20.9251 2.99622 18.0772V8.86901C2.99622 6.02109 5.08643 3.7124 7.66483 3.7124H9.99913'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default LogoutNavIcon
